import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    position: 'absolute',
    right: '0%',
    left: '10px',
    bottom: '5px',
    backgroundColor: '#EBECF4',
  },
  menu: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '12px 0px 12px 0px',
    objectFit: 'contain',
    alignItems: 'center',
  },
  imgLine: {
    display: 'flex',
    position: 'relative',
    marginLeft: '30px',
    marginRight: '15px',
  },
  pagination: {
    position: 'relative',
    display: 'inline-block',
    width: '600px',
    height: '100%',
    textAlign: 'center',
    paddingBottom: '32px',
  },
  sampleAssessmentTableContainerFlex: {
    overflowX: 'auto',
    overflowY: 'auto',
    marginTop: '20px',
    height: 'calc(100vh - 320px)',
    width: 'calc(100vw - 300px)',
    minHeight: '300px',
    '& .MuiTableCell-root': {},
    '& .MuiTableCell-stickyHeader': {
      left: 'unset',
      color: '#2C2D3E',
    },
  },
  sampleAssessmentTableContainerFlexFullWidth: {
    width: 'calc(100vw - 170px)',
  },
  activeFilter: {
    color: '#3560FF',
  },
  roundSmallPink: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#EA2075',
    textAlign: 'center',
  },
  roundSmallBlue: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#3560FF',
    textAlign: 'center',
  },
  icon: {
    color: 'white',
    marginTop: '5px',
    width: '0.5em',
    height: '0.5em',
  },
  exportButton: {
    margin: '20px 30px',
    height: '30px',
  },
  exportButtonIcon: {
    justifyContent: 'start',
  },
  filterMenuCheckbox: {
    width: '14px',
    height: '14px',
    borderRadius: '2px',
    margin: '5px 13px 5px 7px',
    cursor: 'pointer',
    border: 'solid 2px rgba(44, 45, 62, 0.8)',
    '&': {
      color: 'none',
    },
    '&.Mui-checked': {
      color: '#3C419A',
      borderColor: '#100f12',
    },
  }
}));
